 
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaExclamationCircle, FaExclamationTriangle, FaExternalLinkAlt } from 'react-icons/fa';

import moment from 'moment';
import { formatDate } from 'utils/formatter';
import { groupBy } from 'v3/utils/array';

import Text from 'v3/components/Text';
import Modal from 'v3/components/Modal';

import theme from 'v3/theme';
import ModalAlert from './Modal';

function SpeedAlert({ alerts, onClick }) {
  return (
    <Col md={12}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}>
        <FaExclamationCircle color="#FFC107" />
        <Text color="gray" type="regular" style={{ marginBottom: 0 }}>
          Motorista ficou {alerts.length} vezes acima de 80km/h.
        </Text>
        <FaExternalLinkAlt
          onClick={onClick}
          color={theme.colors.light_blue}
          size={14}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </Col>
  );
}

function TravelTimeAlert({ alerts }) {
  return (
    <>
      {alerts.map((alert) => {
        const metadata = JSON.parse(alert.metadata);
        const start = moment(metadata.startedDrivingAt);
        const end = moment(alert.captured_at);
        const duration = moment.duration(end.diff(start)).asMilliseconds();
        const format = duration * 1000 * 60 >= 60 ? 'h [horas e] m [minutos]' : 'h [horas]';

        const travelTime = moment.utc(duration).format(format);

        return (
          <Col md={12}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}>
              <FaExclamationCircle color="#FFC107" />
              <Text color="gray" type="regular" style={{ marginBottom: 0 }}>
                Motorista dirigiu {travelTime} sem fazer parada para descanso.
              </Text>
            </div>
          </Col>
        );
      })}
    </>
  );
}

function LocationNotAllowed() {
  return (
    <Col md={12}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}>
        <FaExclamationCircle color="#FFC107" />
        <Text color="gray" type="regular" style={{ marginBottom: 0 }}>
          Motorista com posicionamento desligado.
        </Text>
      </div>
    </Col>
  );
}

function Alerts({ alerts }) {
  const [modal, setModal] = useState(false);
  const [key, setKey] = useState();
  const [entries, setEntries] = useState();

  const groupedByDate = groupBy(alerts, (item) => formatDate(item.captured_at));

  const grouped = Object.fromEntries(
    Object.entries(groupedByDate).map(([x, v]) => {
      const groupedValues = groupBy(v, (item) => item.slug);

      return [x, groupedValues];
    }),
  );

  return (
    <>
      {Object.values(grouped).length > 0 && (
        <Row md={12}>
          <Col md={12}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem',
              }}
            >
              <FaExclamationTriangle color="#f0ad4e" size={16} />
              <Text type="subtitle" color="dark" style={{ marginBottom: 0 }}>
                Alertas
              </Text>
            </div>
            <div
              style={{
                width: '100%',
                height: '1px',
                backgroundColor: '#d9dde3',
                marginBottom: '0.75rem',
              }}
            />
          </Col>
          <Modal
            size="md"
            heading={key}
            centered
            scrollable
            show={modal}
            body={<ModalAlert alerts={entries} />}
            handleClose={() => setModal(false)}
          />
          {Object.entries(grouped).map(([day, slugs]) => (
            <>
              <Col md={12} className="mt-3">
                <Text color="dark" type="body">
                  {day}
                </Text>
              </Col>
              {Object.entries(slugs).map(([slug, values]) => (
                <>
                  {slug === 'LOCATION_NOT_ALLOWED' && <LocationNotAllowed alerts={values} />}
                  {slug === 'SPEED_GAP_EXCEEDED' && (
                    <SpeedAlert
                      alerts={values}
                      onClick={() => {
                        setKey(key);
                        setEntries(values);
                        setModal(true);
                      }}
                    />
                  )}
                  {slug === 'TRAVEL_TIME_EXCEEDED' && <TravelTimeAlert alerts={values} />}
                </>
              ))}
            </>
          ))}
        </Row>
      )}
    </>
  );
}

export default Alerts;
